import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

import rootReducer from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
let initState = (localStorage['redux-store']) ? JSON.parse(localStorage.getItem('redux-store')) : {}
// Don't restore language preference from localStorage - use app default (English)
if (initState.langReducer) {
  delete initState.langReducer
}
export default () => {
  let store = createStore(rootReducer, initState, composeEnhancers(applyMiddleware(thunk)))
  return { store }
}